import CoinIcon from "../../assets/icons/CoinIcon";
import AddCircleIcon from "../../assets/icons/AddCircleIcon";
import React from "react";

type BalanceCardProps = {
  className?: string;
  textClassName?: string;
  addButtonClassName?: string;
  label: string;
  balance: number | string;
  addLabel: string;
  onAdd: () => void;
};

const BalanceCard = ({
  className,
  textClassName,
  addButtonClassName,
  label,
  balance,
  addLabel,
  onAdd,
}: BalanceCardProps) => (
  <div className={className}>
    <div className={textClassName}>
      <span>{label}:</span>
      <CoinIcon className="gi-coin-icon gi-coin-small" aria-hidden="true" />
      <span>{balance}</span>
    </div>
    <button className={addButtonClassName} type="button" onClick={onAdd}>
      <AddCircleIcon aria-hidden="true" />
      {addLabel}
    </button>
  </div>
);

export default BalanceCard;
